export default __webpack_public_path__ + "static/media/blood-disorder.0fc3934b.jpg";